"use client";

import { useEffect, useRef } from "react";

export interface DefaultLocationSearchMessage {
  action: "default-location-search";
  query: string;
}

function isDefaultLocationSearchMessage(
  data: unknown,
): data is DefaultLocationSearchMessage {
  if (!data || typeof data !== "object") return false;
  const action = (data as { action?: unknown }).action;
  const query = (data as { query?: unknown }).query;
  return action === "default-location-search" && typeof query === "string";
}

export function IframeDefaultLocationListener({
  onQuery,
}: {
  onQuery: (query: string) => void;
}) {
  const lastQueryRef = useRef<string | null>(null);

  useEffect(() => {
    const onMessage = (event: MessageEvent) => {
      if (!isDefaultLocationSearchMessage(event.data)) return;

      const query = event.data.query.trim();
      if (!query) return;

      if (lastQueryRef.current === query) return;
      lastQueryRef.current = query;

      onQuery(query);
    };

    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, [onQuery]);

  return null;
}

